import { defineStore } from 'pinia'
import { ref } from 'vue'
import { DEFAULT_LOCALE, type Locale } from '@/i18n/types'

/**
 * Non-sensitive UI prefs only (sidebar collapsed, theme, locale).
 * Safe to persist to localStorage — contains no auth data.
 */
export const useUiStore = defineStore(
  'ui',
  () => {
    const sidebarCollapsed = ref(false)
    const theme = ref<'light' | 'dark'>('light')
    const locale = ref<Locale>(DEFAULT_LOCALE)

    function toggleSidebar() {
      sidebarCollapsed.value = !sidebarCollapsed.value
    }

    function setLocale(value: Locale) {
      locale.value = value
    }

    function setTheme(value: 'light' | 'dark') {
      theme.value = value
      document.documentElement.classList.toggle('dark', value === 'dark')
    }

    return {
      sidebarCollapsed,
      theme,
      locale,
      toggleSidebar,
      setLocale,
      setTheme,
    }
  },
  {
    persist: {
      key: 'shopsze-admin:ui',
      storage: localStorage,
    },
  },
)
